import { Component } from '@angular/core';
import { ModalRef } from 'asksuite-citrus';
import { CreditsBalanceService } from '@core/services/credits-balance.service';

@Component({
  selector: 'app-credits-balance-modal',
  templateUrl: './credits-balance-modal.component.html',
  styleUrls: ['./credits-balance-modal.component.scss'],
})
export class CreditsBalanceModalComponent {
  protected readonly balances$ = this.creditsBalanceService.balances$;
  protected readonly loading$ = this.creditsBalanceService.loading$;

  constructor(
    private modalRef: ModalRef,
    private creditsBalanceService: CreditsBalanceService
  ) {}

  closeModal(): void {
    this.modalRef.close();
  }
}
